import React from 'react'

function Fundingpage() {
  return (
    <div>Fundingpage</div>
  )
}

export default Fundingpage